import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import QRCode from 'qrcode.react';
import ItemListC from './itemList';
import * as dispositivosActions from 'modules/dispositivos/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';
import { push } from 'react-router-redux';

@connect((store) => ({
  dispositivos: store.get('dispositivos'),
  userRoles: store.getIn(['user', 'roles']),
  eliminarId: store.getIn(['dispositivos', 'eliminarId']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('DISPOSITIVOS'));
    if (this.props.dispositivos.get('lista').size <= 1) this.props.dispatch(dispositivosActions.get());
    if (!this.props.dispositivos.get('codigo')) this.props.dispatch(dispositivosActions.getCodigo());
  };
  acceptDevice = (dispositivoId) => this.props.dispatch(dispositivosActions.accept(dispositivoId));
  delete = (dispositivoId) => this.props.dispatch(dispositivosActions.setState({ eliminarId: dispositivoId }));
  cancelarDelete = () => this.props.dispatch(dispositivosActions.setState({ eliminarId: false }));
  confirmDelete = () => {
    this.props.dispatch(dispositivosActions.delete_(this.props.eliminarId));
    this.cancelarDelete();
  };
  requestPhoto = (dispositivo) => this.props.dispatch(dispositivosActions.requestPhoto(dispositivo.get('id')));
  goToTasks = (dispositivoId) => this.props.dispatch(push(`/dashboard/dispositivos/tasks/${dispositivoId}`));
  render = () => {
    const { eliminarId, userRoles, dispositivos } = this.props;
    return (
      <div>
        <Row className="rowContainer textCenter pt-30">
          <Col md={4} className="pt-30" style={{ alignSelf: 'flex-start' }}>
            {dispositivos.get('codigo') && (
              <div>
                <p>Codigo para sincronizar nuevos dispositivos</p>
                <p className="iconBigBig">{dispositivos.get('codigo')}</p>
                <QRCode size={250} renderAs={'svg'} className="qrCode no-print" includeMargin={false} value={'https://jaits.app/r?codigo=' + dispositivos.get('codigo')} />
              </div>
            )}
          </Col>
          <Col md={{ size: 6 }} className="pt-30">
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding dividerList">
                {dispositivos.get('lista').map((dispositivo) => (
                  <div key={dispositivo.get('id')}>
                    <ItemListC
                      userRoles={userRoles}
                      deleteDevice={this.delete}
                      acceptDevice={this.acceptDevice}
                      dispositivo={dispositivo}
                      requestPhoto={this.requestPhoto}
                      goToTasks={this.goToTasks}
                    />
                    <MaterialUI.Divider />
                  </div>
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
            <Row>
              <Col md="12" className="pt-30">
                <p>
                  <FontAwesome name="check" className="green iconInfo" />
                  Dispositivos por aprobar
                </p>
                <p>
                  <FontAwesome name="check" className="blue iconInfo" />
                  Dispositivos aprobados
                </p>
              </Col>
            </Row>
          </Col>
        </Row>

        <EliminarConfirmacionC eliminarId={eliminarId} confirmar={this.confirmDelete} cancelar={this.cancelarDelete} />
      </div>
    );
  };
}



// WEBPACK FOOTER //
// src/modules/dispositivos/components/main.js